import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {Address} from '../../../models/Address.interface';

interface User {
  id: string;
  displayName: string;
  email: string;
  avatar: string | null;
  phone: string;
  address: Address
}

export const initialState: {
  impersonatedUser: User | null;
  error: string;
} = {
  impersonatedUser: null,
  error: "",
};

const impersonateSlice = createSlice({
  name: "impersonate",
  initialState,
  reducers: {
    impersonateUser(state, action: PayloadAction<User>) {
      state.impersonatedUser = action.payload;
    },
    stopImpersonation(state) {
      state.impersonatedUser = null;
    },
    setImpersonationError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
  },
});

export const {
  impersonateUser,
  stopImpersonation,
  setImpersonationError,
} = impersonateSlice.actions;

export default impersonateSlice.reducer;